/* eslint-disable */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()

export class SigningServiceHttp {
    httpOptions;
    protected token: string = '';
    httpOptionsUpload;
    constructor(private http: HttpClient, private route$: ActivatedRoute) {
        this.httpOptions = {
            headers: new HttpHeaders({'signing_area': '1'})
        };
    }

    get(url: string, options?): Observable<any> {
        const headers = options?.sender_area
            ? { 'signing_area': '1', 'sender_area': '1'}
            : { 'signing_area': '1'};
        return this.http.get(url, {...{ headers: new HttpHeaders(headers) }, ...options});
    }

    post(url: string, body: object): Observable<any> {
        return this.http.post(url, body, this.httpOptions);
    }

    put(url: string, body: object): Observable<any> {
        return this.http.put(url, body, this.httpOptions);
    }

    delete(url: string): Observable<any> {
        return this.http.delete(url, this.httpOptions);
    }

    upload(url: string, body: string): Observable<any> {
        return this.http.post(url, body, this.httpOptionsUpload);
    }
}
